import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import DataTable from "../../components/Table";
import {
  fetchPAymentDetails,
  getDCRDetails,
  getRCSDetails,
  updatePyamentDetailsRowData,
} from "../../store/actions/paymentPatchingActions";
import { toaster } from "../../utils/utils";

const PAYMENT_TABLE_HEADERS = [
  "id",
  "Proposal Number",
  "Bank Reference No.",
  "Pay From",
  "Tx Amount",
  "Deleted Payment",
  "Payment Method",
  "Payment Status",
  "Transaction Date",
  "Total Premium Paid",
  "Tx Payment Status",
  "Tx Reference No",
  "",
];

const PAYMENT_TABLE_KEYS = [
  "id",
  "proposalNumber",
  "bankReferenceNo",
  "payFrom",
  "txAmount",
  "deletedPayment",
  "paymentMethod",
  "paymentStatus",
  "transactionDate",
  "totalPremiumPaid",
  "txPaymentStatus",
  "txReferenceNo",
  "customButtons",
];

const TABS = [
  { key: "DCR", label: "Proposal DCR" },
  { key: "RCS", label: "Proposal RCS" },
];

const PaymentPatching = () => {
  const dispatch = useDispatch();
  const [proposalNumber, setProposalNumber] = useState("");
  const [showEditModal, setshowEditModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [dcrSearchFlag, setDcrSearchFlag] = useState(false);
  const [activeTab, setActiveTab] = useState("DCR");
  const paymentPatchObj = {
    id: "",
    proposalNumber: "",
    txReferenceNo: "",
    transactionDate: "",
    bankReferenceNo: "",
    debitDay: "",
    emandateId: "",
    merchantId: "",
    amount: "",
    cardMaskedValue: "",
    subscriptionDesc: "",
    subscriptionRefid: "",
    amountType: "",
    frequency: "",
    customerRefid: "",
    objectid: "",
  };
  const [paymentPatch, setPaymentPatch] = useState({ ...paymentPatchObj });

  const searchItem = (e) => {
    e.preventDefault();
    if (!proposalNumber) {
      toaster("error", "Please enter proposal number");
      return;
    }
    dispatch(fetchPAymentDetails(proposalNumber));
    setDcrSearchFlag(true);
  };

  let { paymentData, paymentMsg } = useSelector((state) => ({
    paymentData: state.paymentPatchingReducer.paymentData,
    paymentMsg: state.paymentPatchingReducer.paymentMsg,
  }));

  if (!dcrSearchFlag) {
    paymentData = undefined;
  }

  const handleChange = (name, value) => {
    const tempData = JSON.parse(JSON.stringify(paymentPatch));
    tempData[name] = value;
    tempData["id"] = modalData.id;
    tempData["proposalNumber"] = modalData.proposalNumber;
    setPaymentPatch(tempData);
  };

  const updateRowData = () => {
    const rejex =
      /^([1-9]|([012][0-9])|(3[01]))-([0]{0,1}[1-9]|1[012])-\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d:[0-5]?\d$/g;
    const validateDate = rejex.test(paymentPatch.transactionDate);
    if (!validateDate) {
      toaster("error", "Please enter correct date");
    } else {
      dispatch(
        updatePyamentDetailsRowData(paymentPatch, () => {
          dispatch(fetchPAymentDetails(proposalNumber));
          setshowEditModal(false);
          setModalData({});
          setPaymentPatch({ ...paymentPatchObj });
        })
      );
    }
  };

  const checkValid = () => {
    let val = true;
    Object.keys(paymentPatch).map((item) => {
      if (paymentPatch[item] === "" || paymentPatch[item] === null) {
        if (modalData && modalData.emandate && item !== "bankReferenceNo") {
          val = false;
        } else if (
          modalData &&
          modalData.onlyEmandate &&
          item !== "bankReferenceNo"
        ) {
          val = false;
        } else if (
          modalData &&
          !modalData.emandate &&
          !modalData.onlyEmandate &&
          (item === "txReferenceNo" || item === "transactionDate")
        ) {
          val = false;
        }
        return val;
      }
      return val;
    });

    return val;
  };

  const getDCRData = (e) => {
    e.preventDefault();
    if (!proposalNumber) {
      toaster("error", "Please enter proposal number");
      return;
    }
    dispatch(getDCRDetails(proposalNumber));
  };

  const getRCSData = (e) => {
    e.preventDefault();
    if (!proposalNumber) {
      toaster("error", "Please enter proposal number");
      return;
    }
    dispatch(getRCSDetails(proposalNumber));
  };

  const renderDcrPaymentTable = () => {
    if (!paymentData?.length) {
      return null;
    }

    return (
      <div className="proposal-dashboard__table-section payments-page__table-section">
        <DataTable
          convertValueToString={true}
          cellHeaders={PAYMENT_TABLE_HEADERS}
          data={paymentData}
          keys={PAYMENT_TABLE_KEYS}
          fileName="Proposal DCR Data"
          addSerialNo={true}
          onCustomButtonClick={(item) => {
            setModalData(item);
            setshowEditModal(true);
          }}
          showExcelDownload={true}
          PerPageApiData={false}
          paginationItems={paymentData}
          alwaysShown={false}
        />
      </div>
    );
  };

  const handleTabSelect = (key) => {
    setActiveTab(key);
    if (key === "RCS") {
      setshowEditModal(false);
      setModalData({});
      setPaymentPatch({ ...paymentPatchObj });
    }
  };

  const renderTab = (tab) => {
    const isSelected = activeTab === tab.key;

    return (
      <div
        key={tab.key}
        role="button"
        tabIndex={0}
        onClick={() => handleTabSelect(tab.key)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            handleTabSelect(tab.key);
          }
        }}
        className={`view-count proposal-dashboard__filter-card payments-page__tab ${
          isSelected ? "selected" : ""
        }`}
      >
        <span className="proposal-dashboard__filter-label">{tab.label}</span>
      </div>
    );
  };

  const renderProposalSearchForm = (showDcrButton = false) => (
    <form
      className="payments-page__controls-row"
      onSubmit={showDcrButton ? searchItem : getRCSData}
    >
      <div className="payments-page__field payments-page__field--grow">
        <label className="payments-page__label" htmlFor="payment-proposal-number">
          Proposal Number
        </label>
        <input
          id="payment-proposal-number"
          onChange={(e) => setProposalNumber(e.target.value)}
          value={proposalNumber}
          className="payments-page__input payments-page__input--search"
          type="text"
          placeholder="Enter Proposal Number"
          name="proposal"
        />
      </div>
      {showDcrButton ? (
        <>
          <button
            type="submit"
            className="payments-page__btn payments-page__btn--primary"
          >
            Search
          </button>
          <button
            type="button"
            className="payments-page__btn payments-page__btn--secondary"
            onClick={getDCRData}
          >
            Get DCR Call
          </button>
        </>
      ) : (
        <button
          type="submit"
          className="payments-page__btn payments-page__btn--primary"
        >
          Get RCS Call
        </button>
      )}
    </form>
  );

  const renderDcrTabContent = () => (
    <>
      <div className="payments-page__panel payments-page__panel--compact">
        {renderProposalSearchForm(true)}
      </div>
      {paymentMsg?.length ? (
        <div className="payments-page__message">{paymentMsg}</div>
      ) : null}
      {renderDcrPaymentTable()}
    </>
  );

  const renderRcsTabContent = () => (
    <div className="payments-page__panel payments-page__panel--compact">
      {renderProposalSearchForm(false)}
    </div>
  );

  const renderModalField = (label, name, value, placeholder) => (
    <div className="payments-page__field">
      <label className="payments-page__label" htmlFor={`payment-${name}`}>
        {label}
      </label>
      <input
        id={`payment-${name}`}
        className="payments-page__input"
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => handleChange(e.target.name, e.target.value)}
      />
    </div>
  );

  return (
    <>
      <div className="proposal-dashboard payments-page">
        <div className="proposal-dashboard__header payments-page__header">
          <h2 className="proposal-dashboard__title">Payments</h2>
          <p className="proposal-dashboard__subtitle">
            Search proposal payment records and trigger DCR or RCS updates
          </p>
        </div>

        <div className="view-options proposal-dashboard__filters payments-page__tabs">
          {TABS.map(renderTab)}
        </div>

        <div className="payments-page__content">
          {activeTab === "DCR" && renderDcrTabContent()}
          {activeTab === "RCS" && renderRcsTabContent()}
        </div>
      </div>

      {activeTab === "DCR" &&
        showEditModal &&
        Object.values(modalData).length && (
          <MobilePopUp
            heading="Edit Payment Details"
            onClose={() => {
              setshowEditModal(false);
              setPaymentPatch({ ...paymentPatchObj });
            }}
          >
            <>
              <div className="payments-page__modal-form">
                <div className="payments-page__modal-summary">
                  <div>
                    ID: <strong>{modalData.id}</strong>
                  </div>
                  <div>
                    Proposal Number: <strong>{modalData.proposalNumber}</strong>
                  </div>
                  <div>
                    Transaction Amount: <strong>{modalData.txAmount}</strong>
                  </div>
                </div>

                <h4 className="payments-page__modal-section-title">
                  Payment Details
                </h4>
                <div className="payments-page__modal-grid">
                  {renderModalField(
                    "Tx Reference No",
                    "txReferenceNo",
                    paymentPatch.txReferenceNo
                  )}
                  {renderModalField(
                    "Transaction Date",
                    "transactionDate",
                    paymentPatch.transactionDate,
                    "dd-mm-yyyy hh:mm:ss"
                  )}
                  {!modalData.onlyEmandate &&
                    renderModalField(
                      "Bank Reference No",
                      "bankReferenceNo",
                      paymentPatch.bankReferenceNo
                    )}
                </div>
                <p className="payments-page__hint">
                  Transaction date format: dd-mm-yyyy hh:mm:ss
                </p>

                {(modalData.onlyEmandate || modalData.emandate) && (
                  <>
                    <h4 className="payments-page__modal-section-title">
                      Emandate Details
                    </h4>
                    <div className="payments-page__modal-grid">
                      {renderModalField(
                        "Debit Day",
                        "debitDay",
                        paymentPatch.debitDay
                      )}
                      {renderModalField(
                        "Emandate ID",
                        "emandateId",
                        paymentPatch.emandateId
                      )}
                      {renderModalField(
                        "Merchant ID",
                        "merchantId",
                        paymentPatch.merchantId
                      )}
                      {renderModalField("Amount", "amount", paymentPatch.amount)}
                      {renderModalField(
                        "Card Value",
                        "cardMaskedValue",
                        paymentPatch.cardMaskedValue
                      )}
                      {renderModalField(
                        "Subscription Desc",
                        "subscriptionDesc",
                        paymentPatch.subscriptionDesc
                      )}
                      {renderModalField(
                        "Subscription Refid",
                        "subscriptionRefid",
                        paymentPatch.subscriptionRefid
                      )}
                      {renderModalField(
                        "Amount Type",
                        "amountType",
                        paymentPatch.amountType
                      )}
                      {renderModalField(
                        "Frequency",
                        "frequency",
                        paymentPatch.frequency
                      )}
                      {renderModalField(
                        "Customer Ref id",
                        "customerRefid",
                        paymentPatch.customerRefid
                      )}
                      {renderModalField(
                        "Object Id",
                        "objectid",
                        paymentPatch.objectid
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="payments-page__modal-actions">
                <button
                  type="button"
                  className={`payments-page__btn payments-page__btn--primary ${
                    checkValid() ? "" : "payments-page__btn--disabled"
                  }`}
                  onClick={() => updateRowData()}
                  disabled={!checkValid()}
                >
                  Update
                </button>
              </div>
            </>
          </MobilePopUp>
        )}
    </>
  );
};

export default PaymentPatching;
